import React from 'react';
import styled from 'styled-components/macro';
import imgQuote from '../assets/img/quote.svg';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 1.6em 0;

  & .container {
    width: 100%;
    max-width: 500px;
  }

  & img.quote {
    width: 16px;
    height: 13px;
    margin-right: 12px;
  }

  & img.mirror {
    transform: scale(-1, 1);
    margin-left: 12px;
    margin-right: 0;
  }

  & .row {
    & .copy {
      font-family: Roboto-Slab;
      font-style: italic;
      font-size: 15px;
      color: #455764f0;
      letter-spacing: 0.5px;
      line-height: 26px;
    }

    &.by {
      width: 100%;
      text-align: right;
      color: #5d7a8c;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-top: 1em;
    }

    &.title {
      width: 100%;
      text-align: right;
      font-family: Roboto-Italic;
      color: #7b95a6;
      font-size: 0.8em;
      margin-top: 0.8em;
    }
  }
`;

const Quote = ({ by, title, children, quoteStyle, ...props }) => {
  return (
    <Wrapper {...props}>
      <div className="container" style={quoteStyle}>
        <div className="row">
          <div className="copy">
            <img className="quote" src={imgQuote} alt="quote" />
            {children}
            <img src={imgQuote} alt="quote" className="quote mirror" />
          </div>
        </div>

        <div className="row by">{by}</div>

        <div className="row title">{title}</div>
      </div>
    </Wrapper>
  );
};

export default Quote;
